import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { EmailFrame } from "shared/components/EmailFrame";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant,
  Modal,
  Show
} from "shared/components";

const wrapEmailHtml = (html: string) =>
  `<div style="max-width:560px;margin:0 auto">${html}</div>`;

export const EmailPreviewModal = ({
  opened,
  onClose,
  subject,
  via,
  html
}: {
  opened: boolean;
  onClose: () => void;
  subject?: string | null;
  via?: string | null;
  html: string;
}) => (
  <Modal
    opened={opened}
    onClose={onClose}
    panelClassName="flex max-h-[85vh] w-full max-w-[720px] flex-col overflow-hidden"
  >
    <div className="flex shrink-0 items-start justify-between gap-4 border-b border-alpha-100 px-6 py-4">
      <div className="min-w-0 space-y-1">
        <h2 className="text-lg font-bold text-content-1000">Original email</h2>
        <Show if={Boolean(subject)}>
          <p className="truncate text-sm text-content-500">
            <span className="font-medium text-content-700">Subject:</span>{" "}
            {subject}
          </p>
        </Show>
        <Show if={Boolean(via)}>
          <p className="text-xs text-content-300">{via}</p>
        </Show>
      </div>
      <IconButton
        aria-label="Close"
        variant={IconButtonVariant.TEXT_BASE}
        size={IconButtonSize.SM}
        HugeIcon={Cancel01Icon}
        onClick={onClose}
      />
    </div>
    <div className="min-h-0 flex-1 overflow-y-auto bg-background-900 p-6">
      <div className="overflow-hidden rounded-lg bg-white shadow-xs">
        <EmailFrame
          html={wrapEmailHtml(html)}
          title="Original email"
          centered
          className="px-6 py-5"
        />
      </div>
    </div>
  </Modal>
);
